
import './CountriesAttitudeDistribution.scss';

const widgetData = {
  'countries': [
    {
      'name': 'China',
      'attitudes': ['Attack', 'Counteract', 'Pivot', 'Negotiate'],
      'countryCode': 'CN',
    },
    {
      'name': 'France',
      'attitudes': ['Pivot', 'Negotiate', 'Counteract'],
      'countryCode': 'FR',
    },
    {
      'name': 'Kazakhstan',
      'attitudes': ['Negotiate', 'Pivot', 'Counteract' ],
      'countryCode': 'KZ',
    },
    {
      'name': 'EU',
      'attitudes': ['Negotiate', 'Counteract', 'Pivot', ],
      'countryCode': 'EU',
    },
    {
      'name': 'Brazil',
      'attitudes': ['Negotiate', 'Counteract', 'Pivot'],
      'countryCode': 'BR',
    }
   
  ],
}

export const CountriesAttitudeDistribution = () => {
  const attitudeColors = {
    Attack: { color: '#6d0000', background: '#ffb3b3' },
    Negotiate: { color: '#00368d', background: '#B2DDFF' },
    Pivot: { color: '#D96C00', background: '#FFCC80' },
    Counteract: { color: '#A28F00', background: '#FFFBD1' },
  };

  const importAll = (r) => {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  };

  const svgFiles = importAll(require.context('../../assets/flags', false, /\.svg$/));

  return (
    <div className="list-content">
      <div className="report-section">
        <h3>Attitude Distribution</h3>
        <div className="countries-attitude-flex">
          <div className="flex-header">
            <div className='flex-header-country'>Country</div>
            <div className='flex-header-attitude'>Attitudes</div>
          </div>
          {widgetData.countries.map((country) => (
            <div className="flex-row" key={country.name}>
              <div className="flex-country-name">
                <div
                  className='flex-country-flag'
                >
                  <img
                    className='country-flag-icon'
                    src={svgFiles[`${country.countryCode}.svg`]}
                    alt="flag"
                  />
                </div>
                {country.name}
              </div>
              <div className="attitudes">
                {country.attitudes.map((attitude) => (
                  <span
                    key={attitude}
                    style={{
                      backgroundColor: attitudeColors[attitude].background,
                      color: attitudeColors[attitude].color,
                      padding: '3px 7px',
                      margin: '0 5px',
                      borderRadius: '5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {attitude}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
